import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-tag',
  templateUrl: './service-tag.component.html',
  standalone: false,
})
export class ServiceTagComponent {

  @Input() items: string[] = [];
}
